import debug from 'debug'

export const logMain = debug('main')
export const logDebug = debug('debug')
export const logError = debug('error')
export const logAuth = debug('auth')
export const logRouting = debug('routing')
export const logPersistence = debug('persistence')
export const logBootstrap = debug('bootstrap')
export const logAccess = debug('access')
export const logLang = debug('lang')
